import { h, Fragment } from 'preact'
import classnames from 'classnames'

import './style.less'

export default function LightboxCarousel(props) {

	const { 
		images = []
	} = props

	return <div class="lightbox-carousel-container">
		<div class="lightbox-carousel">
			<div class="lightbox-carousel__inner">
			    {images.map(image => {
			    	return <>
			    		<div class="lightbox-carousel-slide">
			    			<div class="lightbox-carousel-slide__inner">
					    		<img class="lightbox-carousel-slide__image" {...image} />
					    	</div>
				    	</div>
			    	</>
			    })}
			</div>
		</div>

		<div class="lightbox-carousel-dialog">
			<div class="lightbox-carousel-dialog__controls">
				<button class="js-lightbox-carousel-dialog-close">Close</button>
			</div>
			<div class="lightbox-carousel-dialog__content">
				<div class="lightbox-carousel-dialog__inner">
				    {images.map(image => {
				    	return <>
				    		<div class="lightbox-carousel-dialog__slide">
				    			
						    		<img class="lightbox-carousel-dialog__slide__image" {...image} />
						    	
					    	</div>
				    	</>
				    })}
				</div>
			</div>
		</div>
	</div>
}